import {GetUserRoleRequestSchema, GetUserRoleResponseSchema} from '@/shared/domain/UserRole'
import {ENDPOINTS} from '@/shared/constants/apiEndPoints'
import api, {HTTPMethod} from '@/shared/api/api'

export const getUserRoleService = signal => {
  return api({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_USER_ROLES,
    requestSchema: GetUserRoleRequestSchema,
    responseSchema: GetUserRoleResponseSchema,
    signal,
  })()
}
